import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { motion } from 'framer-motion'

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 64px;
  width: 100%;

  @media screen and (min-width: ${themeGet('breakpoints.3')}) {
    grid-template-columns: 427px auto;
    gap: 40px;
  }
`

export const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-width: 0;
`

export const AudienceList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${themeGet('space.5')}px;
  min-width: 0;
`

export const AudienceItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: ${themeGet('space.1')}px;
  min-width: 0;
  color: ${themeGet('colors.text.body')};
`

export const VideoArea = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  width: 100%;
  overflow: hidden;
  aspect-ratio: 16 / 9;
`

export const CoverHolder = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  > img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`

export const PlayButton = styled(motion.button)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 12px;
  background-color: ${themeGet('colors.surface.block')};
  color: ${themeGet('colors.text.title')};

  > svg {
    width: 24px;
    height: 24px;
  }
`

export const PauseButton = styled(motion.button)`
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  color: ${themeGet('colors.text.invertedMuted')};

  > svg {
    width: 24px;
    height: 24px;
  }
`

export const Strong = styled.strong`
  font-weight: ${themeGet('fontWeights.1')};
`
